export const updateFilterAction = (filter) => {
  return {
    type: "filters/update",
    payload: filter,
  };
};

export const selectFilter = (state, id) => state.filters.find(f => f.id === id);
export const selectFilters = (state) => state.filters;